module.exports = __webpack_public_path__ + "static/media/refresh-icon.2d7932da.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/refresh-icon.png
// module id = 167
// module chunks = 0